import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute';
import Home from './Components/Home';
import Login from './Components/Login';
import Register from './Components/Register';
import Shop from "./Components/Shop";
import ProductDetail from "./Components/ProductDetail";
import Orders from "./Components/Orders";
import MyDeliveries from './Components/MyDeliveries';
import PendingConfirmations from './Components/PendingConfirmations';
import ReturnAlerts from './Components/ReturnAlerts';
import Layout from './Components/Layout';
import "./App.css"
import "../src/public/css/style.css";
import "../src/public/icon/style.css";
import "../src/public/font/fonts.css";
import "../src/public/css/animate.min.css";
import "../src/public/css/animation.css";
import "../src/public/css/bootstrap-select.min.css";
import PlaceOrders from './Components/PlaceOrders';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <>
    <ToastContainer />
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* All protected routes use Layout */}
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={
                  <ProtectedRoute allowedRoles={['admin', 'receptionist']}>
                    <Shop />
                  </ProtectedRoute>
                } />
                <Route path="/product/:id" element={
                  <ProtectedRoute>
                    <ProductDetail />
                  </ProtectedRoute>
                } />
                <Route path="/orders" element={
                  <ProtectedRoute>
                    <Orders />
                  </ProtectedRoute>
                } />
                  <Route path="/place-orders" element={
                 <PlaceOrders/>
                } />
                <Route path="/my-deliveries" element={
                  <ProtectedRoute allowedRoles={['deliveryman']}>
                    <MyDeliveries />
                  </ProtectedRoute>
                } />
                <Route path="/pending-confirmations" element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <PendingConfirmations />
                  </ProtectedRoute>
                } />
                <Route path="/return-alerts" element={
                  <ProtectedRoute allowedRoles={['admin', 'receptionist']}>
                    <ReturnAlerts />
                  </ProtectedRoute>
                } />
                {/* Fallback: redirect unknown routes to home */}
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </Router>
    </>
  );
}

export default App;